export default __webpack_public_path__ + "static/media/video-user.f23a0302.png";